// 浏览器版本：移除 Node.js 依赖
// import querystring from 'querystring'
// import fs from 'fs'

class DataUtils {
    /**
     * 当前数据的版本号
     * 工具 111 支持配音字段
     * 工具 112 多语言
     * 工具 113 Auto-Menu
     * 工具 115 支持BGM和CG列表，文字效果支持颜色和宽度
     */
    static dataVersion = 115

    /**
     * 当前数据最新的版本号
     */
    static readonly dataLatestVersion = 115

    /**
     * 引擎版本
     * 引擎 108 支持配音字段
     * 引擎 109 支持多语言
     * 引擎 110 Auto-Menu
     * 引擎 115 支持BGM和CG列表，文字效果支持颜色和宽度
     *      */
    static readonly engine_version = 110

    /**
     * 本地化版本
     */
    static readonly LOCALES_VER_112 = 112
}
export default DataUtils
